import { useEffect } from 'react';
import { MdOutlineMarkEmailUnread } from 'react-icons/md';


export default function FormSentPage() {
  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })
  return <div className="container mx-auto px-4">
      <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
      <img alt="Channel Talks logo" src={require('../../Assets/channeltalks-white.png')}/>
      <img alt="Channel Talks logo" src={require('../../Assets/slogan-white.png')}/>
    </div>
    <div className="bg-white mx-auto w-[50%] min-w-[350px] rounded-[10px] px-4 py-3 flex flex-col justify-center items-center gap-4">
      <span className="text-rose-500"><MdOutlineMarkEmailUnread size={150}/></span>
      <h1 className="text-xl font-semibold">Formulario recibido</h1>
      <span className="text-center text-lg">Ya estás participando en el evento.</span>
    </div>
  </div>
}